import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import { get, has, toUpper } from 'lodash';
import { ProfileAction } from '~/actions';
import moment from '~/_moment';
import logoImg from '~/images/footer_logo.png';

import {
  Footer,
  FooterText,
  StatusLabel,
  FooterTextLine1,
  FooterTextLine2,
  FooterLogoContainer,
} from './styles';

class LayoutFooter extends Component {
  componentDidMount() {
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.props.loadStatus();
      }, 60000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getStationName = (stationId) => {
    const {
      damProfile: { seismic },
    } = this.props;

    const keyStation = toUpper(stationId);

    return get(seismic, `remap_station_name.${stationId}`, keyStation);
  };

  isOffline = (lastSync) => moment().unix() - lastSync.unix() > 900;

  pressureDamStatus = (status) => (
    <StatusLabel offline={this.isOffline(status.start)} title={status.start.format('LLLL')}>
      {this.isOffline(status.start) ? <Icon type="close-circle" /> : <Icon type="global" />}{' '}
      Datalogger {this.isOffline(status.start) && `(${status.start.fromNow()})`}
    </StatusLabel>
  );

  seismicDamStatus = ({ station, registedStation, deprecatedStation }) => (
    <span>
      {station.map(
        (eachStation, index) =>
          eachStation.syncAt &&
          registedStation[eachStation.station] && (
            <StatusLabel
              key={`station-index-${index}`}
              title={eachStation.syncAt.format('LLLL')}
              offline={this.isOffline(eachStation.syncAt)}
              deprecated={get(deprecatedStation, eachStation.station, false)}
            >
              {get(deprecatedStation, eachStation.station, false) ? (
                <Icon type="disconnect" />
              ) : this.isOffline(eachStation.syncAt) ? (
                <Icon type="close-circle" />
              ) : (
                <Icon type="global" />
              )}

              {` ${this.getStationName(eachStation.station)} `}
              {get(deprecatedStation, eachStation.station, false)
                ? '(ปิดการใช้งาน)'
                : this.isOffline(eachStation.syncAt) && `(${eachStation.syncAt.fromNow()})`}
            </StatusLabel>
          ),
      )}
    </span>
  );

  render() {
    const { damStatus, damProfile } = this.props;

    console.log({ damStatus, damProfile });

    return (
      <section>
        <Footer className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              {has(damStatus, 'pressure') && this.pressureDamStatus(damStatus.pressure)}
              {has(damStatus, 'seismic') &&
                this.seismicDamStatus({
                  station: damStatus.seismic,
                  registedStation: get(damProfile.seismic, 'station', {}),
                  deprecatedStation: get(damProfile.seismic, 'deprecated', {}),
                })}
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 clearfix">
              <FooterLogoContainer>
                <img src={logoImg} alt="" />
              </FooterLogoContainer>
              <FooterText>
                <FooterTextLine1>
                  (2014 - {moment().format('YYYY')}) by Regional Irrigation Office 1 of Royal
                  Irrigation Department, Thailand
                </FooterTextLine1>
                <FooterTextLine2>Brought to you by NDS | TryCatch™</FooterTextLine2>
              </FooterText>
            </div>
          </div>
        </Footer>
      </section>
    );
  }
}

export default connect(
  (state) => ({
    damProfile: state.DamProfile,
    damStatus: state.DamStatus,
  }),
  {
    loadStatus: ProfileAction.loadStatus,
  },
)(LayoutFooter);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Layout/LayoutFooter.js